import { OrgOwnedModel } from "./BaseModel";

export interface RemoteControl extends OrgOwnedModel {
  name: string;
  serialNumber: string;
  version: string;
  requiredAppVersion: string;
  description: string;
  yamlContent: string;
  token: string;
  robotId: string;
  blobUrl: string;
  deploymentId: string;
  deploymentPackStamp: number;
  deploymentPackStampOnDevice: number;
}

export function createRemoteControl(_id = ''): RemoteControl {
  return {
    _id: _id,
    orgId: "",
    name: "",
    serialNumber: "",
    version: "",
    description: "",
    requiredAppVersion: "",
    yamlContent: "",
    token: "",
    robotId: "",
    blobUrl: "",
    deploymentId: "",
    deploymentPackStamp: 0,
    deploymentPackStampOnDevice: 0,
  };
}

//9-TJ5KSP~PLsi#+